import { ChartNames } from "store/slice/charts/chartsSlice.types";

export const SAVE_SEARCH = "currentSearch";
export const REDIRECT_PACE = "/pace/setup";
export const REDIRECT_LD = "/leadership-dynamics/search";
export const APP_LANG = "EN";
export const PACE_LABS_CHARTS = ["LD5", "LD7", "LD4", "LD3", "LD2", "LD8"] as ChartNames[];

export const LOCATIONS = {
    INTERNATIONAL: "International",
    LOCAL: "local",
};
